module.exports = __webpack_public_path__ + "img/cost-logo.d2296ddf.png";